import * as zoneActions from '@redux/modules/zoneV4'

import usePaginatedLoader from './usePaginatedLoader'

function useZonesV4(options = {}){
  const { searchFilter } = options

  const { items: filteredZonesV4, loading, hasMore, callbacks } = usePaginatedLoader({
    loadFn: zoneActions.loadZonesV4,
    entityKey: 'zonesV4',
    queryOptions: {
      name: searchFilter || '',
    },
  })

  return { filteredZonesV4, loading, hasMore, callbacks }
}

export default useZonesV4
